// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"376ff945","210":"31b82229","248":"a1069cd1","453":"1407b060","584":"f045acdc"}[chunkId] + ".chunk.js";
};